import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={11}
    height={8}
    fill="none"
    {...props}
  >
    <path
      stroke="#AAA"
      strokeLinecap="round"
      strokeWidth={2}
      d="M1 1.5 5.5 6 10 1.5"
      opacity={0.8}
    />
  </svg>
)
export default SvgComponent
